import React from "react";

import "./App.css";
import FetchRestCountries from "./components/fetchRestCountries";
// import SearchBar from "./components/SearchBar";

function App() {
  return <FetchRestCountries />;
  // return <SearchBar />;
}

export default App;
